// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2GCWm","large":"styles_large__2FToP"};